import { render, staticRenderFns } from "./ActivityContainer.vue?vue&type=template&id=b5fecf58&"
import script from "./ActivityContainer.vue?vue&type=script&lang=ts&"
export * from "./ActivityContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports